import {
    Button,
    Flex,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Skeleton,
    Table,
    Tbody,
    Td,
    Text,
    Tr, useColorModeValue
} from '@chakra-ui/react';
import Card from '../../../../components/Card/Card';
import {useState} from 'react';
import {useQuery} from 'react-query';
import {apiService} from '../../../../services/ApiService';
import {FilterIcon} from '../../../../components/Icons/Icons';
import {parseDateTime} from '../../../../services/Utils';

const statsRangeOptions = {
    '': 'All time',
    week: 'This Week',
    month: 'This Month',
    year: 'This Year'
};

const userPurchaseFields = [
    { key: 'txCount', label: 'Transaction count' },
    { key: 'literCount', label: 'Liter Count' },
    { key: 'savingsAmount', label: 'Savings Amount' },
];

const formatValue = (key, value) => {
    if (!value) {return '';}

    if (key ==='literCount') {
        return `${value} L`;
    }

    if (key === 'savingsAmount') {
        return `$ ${value}`;
    }

    return String(value);
};

const UserPurchasesStats = ({userCid = null}) => {
    const textColor = useColorModeValue('gray.700', 'white');
    const [statsRange, setStatsRange] = useState('');

    const handleStatsRangeButton = (type) => {
        if (type !== statsRange) {
            setStatsRange(type);
        }
    };

    const { data: stats, isFetching: isStatsFetching } = useQuery({
        queryKey: ['user-purchases-stats', statsRange, userCid],
        refetchOnWindowFocus: false,
        queryFn: async () => {

            const params = {};

            if(statsRange){
                params.range = statsRange;
            }
            if(userCid){
                params.userCid = userCid;
            }

            const response = await apiService.getUserPurchasesStats(params);
            return response.data;
        },
        retry: false,
        refetchInterval: 30000,
    });

    return (
        <>
            <Flex justifyContent="space-between" alignItems="center" mb={2}>
                <Text fontSize='24px' fontStyle='normal' fontWeight='700' color={textColor} mb='0px' className="page-name">{userCid ? `Other purchases by ${userCid}` : 'Stats:'}  </Text>
                <Menu variant="filter">
                    <MenuButton
                        as={Button}
                        leftIcon={
                            <FilterIcon color="white" fontSize="24px" ml="0px" mr="0px" />
                        }
                        variant="secondary-md"
                        color="white"

                        w="200px"
                        px="24px !important"
                    >
                        {statsRangeOptions[statsRange]}
                    </MenuButton>
                    <MenuList className="context-menu">
                        {Object.entries(statsRangeOptions).map(([value, label]) => (
                            <MenuItem
                                key={value}
                                onClick={() => handleStatsRangeButton(value)}
                            >
                                {label}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Menu>
            </Flex>
            {isStatsFetching ?
                <Card padding="24px" mb="40px">
                    <Table>
                        <Tbody>
                            {userPurchaseFields.map(({ key, label }) => (
                                <Tr key={key}>
                                    <Td w='300px' verticalAlign="top" border="unset">
                                        <Text variant="title">{label}</Text>
                                    </Td>
                                    <Td verticalAlign="top" border="unset">
                                        <Skeleton height="20px" borderRadius="6px" />
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Card>
                :
                <Card padding="24px" mb="40px">
                    <Table>
                        <Tbody>
                            {userPurchaseFields.map(({ key, label }) => (
                                <Tr key={key}>
                                    <Td w='300px' verticalAlign="top" border="unset">
                                        <Text variant="title">{label}</Text>
                                    </Td>
                                    <Td verticalAlign="top" border="unset">
                                        {formatValue(key, stats?.[key])}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Card>
            }
        </>
    );
};

export default UserPurchasesStats;